<script>
    export let disabled = false;
    export let classes = '';
    export let title = 'Title here';
</script>

<style>
    .button {
        font-family: Camphor W01 Bold;
        @apply rounded-full bg-white border-2 border-white text-blue-700 w-full px-12 py-6;
    }

    .button:focus {
        @apply border-blue-500 !important;
        outline: none;
        box-shadow: 0 0 5px rgba(81, 203, 238, 1);
    }

    .button:hover {
        @apply border-gray-500 transition duration-100 ease-in;
    }

    .button.active {
        @apply border-blue-500;
    }

    .disabled, .disabled:hover {
        cursor: default;
        @apply opacity-50;
        border-color: transparent;
        color: #4A82BE;

        background: repeating-linear-gradient(
            -45deg,
            #C6C6C6,
            #C6C6C6 2px,
            #DCDCDC 2px,
            #DCDCDC 10px
        );
    }
</style>

<button {disabled} class:disabled={disabled} class="button {classes}" on:click>{title}</button>